module.exports = __webpack_public_path__ + "media/hit_redFlag.aab356bd.mp3";